(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.querySelector('.shopify-section-header');
            this.headerWrapper = document.querySelector('.header-wrapper');
            this.headerIsAlwaysSticky =
                this.getAttribute('data-sticky-type') === 'always';
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');

            this.headerCoords = {};
            this.calcHeaderCoords();

            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
        }

        disconnectedCallback() {
            this.removeEventListener(
                'preventHeaderReveal',
                this.hideHeaderOnScrollUp,
            );
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        calcHeaderCoords() {
            const clientRect = this.getBoundingClientRect();
            const pageYOffset =
                window.pageYOffset || document.documentElement.scrollTop;
            this.headerCoords.bottom = pageYOffset + clientRect.bottom;
            this.headerCoords.top = pageYOffset + clientRect.top;
        }

        onScroll() {
            const scrollTop =
                window.pageYOffset || document.documentElement.scrollTop;

            if (this.headerIsAlwaysSticky) {
                if (this.header.classList.contains('color-background-overlay')) {
                    if (scrollTop > this.header.offsetHeight + 1) {
                        this.header.classList.remove('color-background-overlay');
                        this.header.classList.add(
                            'color-background-overlay-hidden',
                            'shopify-section-header-sticky',
                        );
                    }
                }

                if (this.header.classList.contains('color-background-overlay-hidden')) {
                    if (scrollTop < this.header.offsetHeight) {
                        this.header.classList.add('color-background-overlay');
                        this.header.classList.remove(
                            'color-background-overlay-hidden',
                            'shopify-section-header-sticky',
                        );
                    }
                }
            }

            if (
                scrollTop > this.currentScrollTop &&
                scrollTop > this.headerCoords.bottom
            ) {
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (
                scrollTop < this.currentScrollTop &&
                scrollTop > this.headerCoords.bottom
            ) {
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);

                    this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                    }, 66);

                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerCoords.top) {
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add(
                'shopify-section-header-hidden',
                'shopify-section-header-sticky',
            );
            this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');

            if (this.header.classList.contains('color-background-overlay')) {
                this.header.classList.remove('color-background-overlay');
                this.header.classList.add('color-background-overlay-hidden');
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove(
                'shopify-section-header-hidden',
                'shopify-section-header-sticky',
                'animate',
            );

            if (this.header.classList.contains('color-background-overlay-hidden')) {
                this.header.classList.add('color-background-overlay');
                this.header.classList.remove('color-background-overlay-hidden');
            }
        }

        closeMenuDisclosure() {
            this.disclosures =
                this.disclosures || this.header.querySelectorAll('details-disclosure');
            if (typeof DetailsDisclosure !== 'undefined') {
                this.disclosures.forEach(disclosure => {
                    disclosure.close();
                });
            }
            this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
            this.disclosureLists.forEach(disclosureList => {
                disclosureList.setAttribute('hidden', true);
            });
        }
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
    class CartNote extends HTMLElement {
        constructor() {
            super();
            this.spinnerIcon = this.querySelector('.cart__note-loading');
            this.successIcon = this.querySelector('.cart__note-success');
            this.textarea = this.querySelector('textarea');
            this.cartButtons = document.querySelector('.cart__ctas');

            this.textarea.addEventListener(
                'input',
                debounce((event) => {
                    this.spinnerIcon.style.display = 'block';
                    this.successIcon.style.display = 'none';
                    this.cartButtons.style.pointerEvents = 'none';
                    this.cartButtons.style.opacity = '0.7';

                    const body = JSON.stringify({ note: event.target.value });

                    fetch(`${routes.cart_update_url}`, {
                        ...fetchConfig(),
                        ...{ body },
                    })
                        .then((response) => {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }
                            return response.json();
                        })
                        .then((data) => {
                            this.successIcon.style.display = 'block';

                            setTimeout(() => {
                                this.successIcon.style.display = 'none';
                            }, 2000);
                        })
                        .catch((error) => {
                            console.error(
                                'There was a problem with the fetch operation:',
                                error
                            );
                        })
                        .finally(() => {
                            this.spinnerIcon.style.display = 'none';
                            this.cartButtons.removeAttribute('style');
                        });
                }, 300)
            );
        }
    }

    customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
